import React, { useEffect, useState } from 'react';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Collapse, Box, IconButton, ListItemButton } from '@mui/material';
import { Dashboard, Folder, People, Event, AccountCircle, ExitToApp, ChevronLeft, ChevronRight } from '@mui/icons-material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import Logo from '../assets/images/logo-white.png';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import FileOpenOutlinedIcon from '@mui/icons-material/FileOpenOutlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import AddReactionOutlinedIcon from '@mui/icons-material/AddReactionOutlined';
import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';
import PermContactCalendarOutlinedIcon from '@mui/icons-material/PermContactCalendarOutlined';
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import BalanceOutlinedIcon from '@mui/icons-material/BalanceOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import { useNavigate } from 'react-router';
import { CONSTANTS } from '../config/constants';
import { isMobile } from 'react-device-detect';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';

const Sidebar = ({ open, toggleSidebar }) => {
  const navigate = useNavigate();

  const [openMenu, setOpenMenu] = useState(null); // Track the currently expanded menu

  const handleMenuClick = (menu) => {
    setOpenMenu((prev) => (prev === menu ? null : menu)); // Toggle the clicked menu
  };
  const userType = JSON.parse(localStorage.getItem('lawgeekUser')) || null;
  var menus = null;

useEffect(() => {
  menus = userType.userTypeID == 2 ? adminMenus : userMenu
}, []);

const adminMenus = [ { title: 'Dashboard', icon: <Dashboard />, link: '/admin' }]

  const userMenu = [

    { title: 'Dashboard', icon: <Dashboard />, link: '/' },
    {
      title: 'Case Management',
      icon: <Folder />,
      subMenus: [
        { title: 'Add Case', icon: <PostAddOutlinedIcon />, link: '/case-management/add' },
        { title: 'All Cases', icon: <ListOutlinedIcon />, link: '/case-management/case/0' },
        { title: 'Open Cases', icon: <FileOpenOutlinedIcon />, link: '/case-management/case/1' },
        { title: 'My Case History', icon: <ManageSearchOutlinedIcon />, link: '/case-management/case/2' },
      ],
    },
    {
      title: 'Lawyers',
      icon: <People />,
      subMenus: [
        { title: 'Add Lawyers', icon: <AddReactionOutlinedIcon />, link: '/lawyer/add' },
        { title: 'Lawyers', icon: <EmojiEmotionsOutlinedIcon />, link: '/lawyer/list' },
      ],
    },
    {
      title: 'Clients',
      icon: <People />,
      subMenus: [
        { title: 'Add Clients', icon: <AddCircleOutlineOutlinedIcon />, link: '/client-management/add' },
        { title: 'Clients', icon: <GroupsOutlinedIcon />, link: '/client-management/clients/', param: CONSTANTS.clientTypes[0].clientID },
        { title: 'Opposing side party', icon: <SupervisorAccountOutlinedIcon />, link: '/client-management/clients/', param: CONSTANTS.clientTypes[1].clientID },
        { title: 'Case Counsel', icon: <VisibilityOutlinedIcon />, link: '/client-management/clients/', param: CONSTANTS.clientTypes[2].clientID },
      ],
    },
    {
      title: 'Hearing Details',
      icon: <Event />,
      subMenus: [
        { title: 'Add Hearing', icon: <NoteAddOutlinedIcon />, link: '/hearing/add' },
        { title: 'Open Hearings', icon: <LockOpenOutlinedIcon />, link: '/hearing/0' },
        { title: 'Closed Hearings', icon: <FactCheckOutlinedIcon />, link: '/hearing/1' },
      ],
    },
    {
      title: 'Calendar', link: '/mycalendar',
      icon: <CalendarMonthOutlinedIcon />,
    },
    {
      title: 'Document Management',
      icon: <DocumentScannerOutlinedIcon />,
      subMenus: [
        { title: 'Documents', icon: <EmojiEmotionsOutlinedIcon />, link: '/documents' },
        { title: 'Add Documents', icon: <AddReactionOutlinedIcon />, link: '/documents/add' },
      ],
    },
    {
      title: 'Todo',
      icon: <AssignmentOutlinedIcon />,
      subMenus: [
        { title: 'Create', icon: <EmojiEmotionsOutlinedIcon />, link: '/documents' },
        { title: 'list my todo', icon: <AddReactionOutlinedIcon />, link: '/documents/add' },
      ],
    },
    { title: 'Profile', icon: <AccountCircle />, link: '/profile' },
  ];

  const navigateTo = (data) => {
    var link = data.link;
    if (data.param) {
      link += data.param;
    }
    if (link) {
      if (isMobile) {
        toggleSidebar();
      }
      navigate(link);
    }
  }

  const logout = () => {
    localStorage.clear();
    navigate('/auth/login');
  }

  return (
    <Drawer
      variant="permanent"
      open={open}
      sx={{
        width: open ? 240 : 0,
        flexShrink: 0,
        backgroundColor: '#12132b',
        '& .MuiDrawer-paper': {
          width: open ? 240 : 0,
          transition: 'width 0.3s ease',
          overflowX: 'hidden', // Prevent overflow
          bgcolor: '#121f40',
        },
      }}

    >
      <Box sx={{ height: '100%', overflow: 'hidden' }}> 
       {userType.userTypeID == 4 && <List style={{ backgroundColor: '#12132b', color: '#d1d1e6', height: '110vh' }}>
          {adminMenus && adminMenus.map((menuItem, index) => (
            <div key={index}>
              <ListItem disablePadding>
                <ListItemButton onClick={() => { handleMenuClick(index); navigateTo(menuItem) }}>
                  <ListItemIcon style={{ color: '#d1d1e6' }}>{menuItem.icon}</ListItemIcon>
                  <ListItemText primary={menuItem.title} />
                  {menuItem.subMenus && menuItem.subMenus.length &&
                    (openMenu ? <ExpandLess /> : <ExpandMore />)}
                </ListItemButton>
              </ListItem>

              {menuItem.subMenus && menuItem.subMenus.length && (
                <Collapse in={openMenu == index} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {menuItem.subMenus.map((subMenuItem, subIndex) => (
                      <ListItemButton key={subIndex} sx={{ pl: 4 }} onClick={() => navigateTo(subMenuItem)}>
                        <ListItemIcon style={{ color: '#d1d1e6' }}>{subMenuItem.icon}</ListItemIcon>
                        <ListItemText primary={subMenuItem.title} />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              )}
            </div>
          ))}

        </List>}
        {userType && userType.userTypeID != 4 && <List style={{ backgroundColor: '#12132b', color: '#d1d1e6', height: '110vh' }}>
          {userMenu && userMenu.map((menuItem, index) => (
            <div key={index}>
              <ListItem disablePadding>
                <ListItemButton onClick={() => { handleMenuClick(index); navigateTo(menuItem) }}>
                  <ListItemIcon style={{ color: '#d1d1e6' }}>{menuItem.icon}</ListItemIcon>
                  <ListItemText primary={menuItem.title} />
                  {menuItem.subMenus && menuItem.subMenus.length &&
                    (openMenu ? <ExpandLess /> : <ExpandMore />)}
                </ListItemButton>
              </ListItem>

              {menuItem.subMenus && menuItem.subMenus.length && (
                <Collapse in={openMenu == index} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {menuItem.subMenus.map((subMenuItem, subIndex) => (
                      <ListItemButton key={subIndex} sx={{ pl: 4 }} onClick={() => navigateTo(subMenuItem)}>
                        <ListItemIcon style={{ color: '#d1d1e6' }}>{subMenuItem.icon}</ListItemIcon>
                        <ListItemText primary={subMenuItem.title} />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              )}
            </div>
          ))}

        </List> }
        
        <Box sx={{ position: 'absolute', bottom: 0, width: '100%', cursor: 'pointer' }}>
          <ListItem button onClick={logout}>
            <ListItemIcon sx={{ color: '#d1d1e6' }}>
              <ExitToApp />
            </ListItemIcon>
            <ListItemText primary="Logout" sx={{ color: '#d1d1e6' }} />
          </ListItem>
        </Box>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
